/**
 * @generated SignedSource<<7aae4da78b2af685545ec48d5c92c793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoScheduleSetPublishAtMutation$variables = {
  id: string;
  publishAt?: string | null;
  scheduledArchiveAt?: string | null;
};
export type WorkspaceTodoScheduleSetPublishAtMutation$data = {
  readonly todoWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledArchiveAt: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly scheduledPublishAt: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
    };
  };
};
export type WorkspaceTodoScheduleSetPublishAtMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledArchiveAt: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly scheduledPublishAt: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
    };
  };
};
export type WorkspaceTodoScheduleSetPublishAtMutation = {
  rawResponse: WorkspaceTodoScheduleSetPublishAtMutation$rawResponse;
  response: WorkspaceTodoScheduleSetPublishAtMutation$data;
  variables: WorkspaceTodoScheduleSetPublishAtMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publishAt"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scheduledArchiveAt"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newPublishAt",
    "variableName": "publishAt"
  },
  {
    "kind": "Variable",
    "name": "scheduledArchiveAt",
    "variableName": "scheduledArchiveAt"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FormattedDate"
  }
],
v6 = [
  (v4/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isDate"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoScheduleSetPublishAtMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledArchiveAt",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoScheduleSetPublishAtMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledArchiveAt",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d544c680801f5a67d8bec96a44a160de",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoScheduleSetPublishAtMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoScheduleSetPublishAtMutation(\n  $id: ID!\n  $publishAt: String\n  $scheduledArchiveAt: String\n) {\n  todoWorkspace(id: $id) {\n    updateScheduledPublishAt(newPublishAt: $publishAt, scheduledArchiveAt: $scheduledArchiveAt) {\n      id\n      scheduledPublishAt {\n        isoString\n        ...FormattedDate\n      }\n      scheduledArchiveAt {\n        isoString\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "f323a8ba54f7295852047f31c8b19442";

export default node;
